import React from 'react';
import styled, { StylesProps } from '../../../lib/styles';
import popularSectionStyles from './PopularBlock_styles';
import Spacer from '../../../components/presentational/Spacer';
import { Holiday } from '../../../models/holiday';
import { Destination } from '../../../models/travelCollection';
import LightDestination from './LightDestination';
import Button from '../../../components/presentational/Button';
import { trackEvent } from '../../../lib/ga';
import { SHOW_MORE_DESTINATIONS } from '../lib/ga';

export interface PopularBlockProps {
  destinations?: Destination[];
  holidays?: Holiday[];
  slotKey?: string;
  moreDestinationsURL?: string;
}

const PopularBlock = ({
  destinations = [],
  styles,
  moreDestinationsURL,
}: PopularBlockProps & StylesProps<typeof popularSectionStyles>) => (
  <Spacer align={'center'} space={'m'} className={styles.container}>
    <Spacer width={1160} space={['m', 'l']}>
      <div className={styles.columnContainer}>
        {destinations.length > 0 && (
          <Spacer flex={'1 1 0%'} space={'m'}>
            <h1 className={styles.title}>Popular destinations</h1>

            {destinations.map((destination: Destination, i: number) => (
              <LightDestination key={i} size={'l'} destination={destination} />
            ))}
            {moreDestinationsURL && (
              <Button
                color={'light_grey'}
                onClick={() => {
                  window.open(moreDestinationsURL, '_blank');
                  trackEvent(SHOW_MORE_DESTINATIONS, { transport: 'beacon' });
                }}
              >
                Show all destinations
              </Button>
            )}
          </Spacer>
        )}
      </div>
    </Spacer>
  </Spacer>
);

export default styled(popularSectionStyles)(PopularBlock);
